<ng-template [cdkPortalOutlet]="portal$ | async"></ng-template>
